import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    context: 'selected',
    path: 'configuration_organization_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
